import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import {
  SetHasRequestError,
  SetHasTriedToSave
} from './precheckin-shared-state.actions';
import {
  defaultSharedState,
  IPrecheckinSharedStateModel
} from './precheckin-shared-state.model';

@State<IPrecheckinSharedStateModel>({
  name: AppStoreKeys.PrecheckinSharedState,
  defaults: defaultSharedState
})
@Injectable()
export class PreCheckinSharedState {
  @Selector()
  public static hasRequestError(state: IPrecheckinSharedStateModel): boolean {
    return state.hasRequestError;
  }

  @Selector()
  public static hasTriedToSave(state: IPrecheckinSharedStateModel): boolean {
    return state.hasTriedToSave;
  }

  @Action(SetHasRequestError)
  setHasRequestError(
    ctx: StateContext<IPrecheckinSharedStateModel>,
    { hasRequestError }: SetHasRequestError
  ): void {
    ctx.patchState({
      hasRequestError
    });
  }

  @Action(SetHasTriedToSave)
  setHasTriedToSave(
    ctx: StateContext<IPrecheckinSharedStateModel>,
    { hasTriedToSave }: SetHasTriedToSave
  ): void {
    ctx.patchState({
      hasTriedToSave
    });
  }
}
